/** Plain style values of the Pro wizard (see desk.tsx). */

/** Hairlines: the edge of a group card, and the rule between its rows. */
export const LINE = '#E3E3EA'
export const LINE_SOFT = '#EEEEF3'

/** Width of the form column; the phone preview sits beside it. */
export const FORM_MAX = 680

/** The secondary, outlined button the wizard uses next to its coral primary. */
export const outlinedBtnSx = {
  height: 36,
  px: 1.75,
  borderRadius: '10px',
  border: `1px solid ${LINE}`,
  bgcolor: '#fff',
  color: '#1B1C38',
  fontSize: 13.5,
  fontWeight: 700,
  whiteSpace: 'nowrap',
  transition: 'background-color .15s ease, transform .1s ease',
  '&:hover': { bgcolor: '#F7F7F9', borderColor: 'rgba(27,28,56,.24)' },
  '&:active': { transform: 'scale(.98)' },
} as const

export const primaryBtnSx = {
  height: 36,
  px: 1.75,
  borderRadius: '10px',
  fontSize: 13.5,
  fontWeight: 700,
  whiteSpace: 'nowrap',
  boxShadow: 'none',
  transition: 'background-color .15s ease, transform .1s ease',
  '&:hover': { boxShadow: 'none' },
  '&:active': { transform: 'scale(.98)' },
} as const
